import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, initFirebaseAuth } from '@helios/auth-firebase-web';
import { App } from './App';
import { getFirebaseConfig } from './auth/firebase-config';
import './index.css';

// Initialize Firebase
initFirebaseAuth(getFirebaseConfig());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
